var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "rotate(-70)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.6265,
    y: 5.04309,
    width: 15.8307,
    height: 10.9534,
    transform: "rotate(44.6465 21.6265 5.04309)",
    fill: "#134824"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2354_75386",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2354_75386",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFH0lEQVR4nO2cS2hcVRiAj/gA327ER33h1rfVhRvdKJ35/0kLahAVK4KuutJWrUFMQReCqE3+fxKDlqpdCNWd4saKiKIgSkVS4z3/jKGt1YWoIJU2Jhr5bxJN4507r/s8cz44MIuZm3O+nHse//nvNcbj8Xg8Ho/H4/F4PNkRMFwvjHuE4YgQ/ikEP1iG1xsTeHWG1XAbYdxqCRaEcTGizAtVt+Rdx9IjhDtaCD6hBAxP511X5yWLl52dZC87Q8ledoaSvewMJXvZGUr2sjOU7GVnKNnLNtlJHmjZEi/5uCV8cpbhQi36WRjmkpBtGbabQcEy3h8nuTFerf7/N7A9qZ49MLItw2fREmDO1mtDUb9p7hy6wA8jXWIZP+1GsjJDGy/2Y3aXWKred8KtTHgsarhYjTCOpDFBOj+MCOFGYdwrBLvaBe8bjJDUZDiQsjshYLhVJ8i0l34DL9sSfJG25FLLtmOVG4RgW4PwwUMvDp/e83UYg6xEh6VMx2LCOLL6jE9lBRN4ZY/XesQS/r18raNpbWRWlXnhoatMWXd8luFgr7LDu6OOm6W+6dI0NzL/9Wrcbcocu7B9yG7Ft1MbLkp8rCY4ZMoeILIJy24jOoyZBJO4rrmzdpkleCbMCWlbT5gzLkThbIKyhfCp6F6Jx4Shsvb7oez2dTxsXAl12gRkf89wuU6QUZJb7TS1Z3cwdLxhXIon2z5l69KxG8mKHatc0kbyQrM+dK0pUpqWJDHx9CFbqHbjqqVfOCb3HTOh2mOmSAmHtnUuXMayqw8L4XdC+Llu12O/y1CJ3c4T7jBFYimrExORnOSYHV9nqCxNkCWRrISps5ys6DRll1KyknLI8mCSsksrWdF1pqQkOknZpZasaCxAUhSdhOzSS1Y0uiVhlKuYsp2QvIJQdUvaonuR3aTqNc5ITjVEyf3Jjh3Wyii5qLKF4G3nJLeLoOUhe/l03T3JK1jGV4siO2C41xJ8okU/G5eYDc/wkot/JDVmO4kwzGQheuBli0bRMhI9sLKDSVxnGf7KUvSSbAz6yRspHZbwzawl/1vquNm4zuKiOUkIn81NshaCbcZljkzVzkjjEKCroYNgIRjH64yrNKh6U5arjJgyYlzk6xfuOFMYn88iete2NzOMGhexVL1L3/zSy+0tjAcswXRimxqXttUrzExuuEII3+tNCOzSB31WrmXHKudbxikveRVfTq0/1Y7jE5bgj95ubXwu8aifaz1ZqHaLZfymj563R5d+cX+ja9kuSf5o9LZTwgTvjrIusUWBGV36JZnx5NTE15y6/Vxh/KDPiWq+MYHrezgWi1zF6ORpGR41rjD78qbzhHB/AquBl3o+8CXcrUngy3kjhzWrs1AJh/0yPTp8miXYl4DkH/WuyLs9zudpBHW4M++2FBbLeHcSkoXx3bzbUuzJj+DnNSuGuYDhcX02RB907/ARs6OafZ93ewpLVHhTNyhrv7ckO1b01nxaUAKmefgsIfh9rTTtxV29woFwv66982lFCRCGB6LE6ZDRhej5Zr12cz4tKAnC+E7kBiFq6GixVQ4G8WVQ3SKEzRa99LjK1l4cNxlaxvcX9w6fnHc7Ck8/WfuW4auZ1zaenXcbSkHURNiRZIJ9dqxyTt71Lw1C+HHXoglf0e163nUvFZZqD3Xei/GnuDd4eWLQoLxleKvNWPybrix0ze1l9ilbn6e2jB8K4y+W8FcN2of/gPHaPQOVauXxeDwej8fj8Xg8xiH+AV1ZqjGzZnIYAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.67872f35789a637f8ad26d314b9134cd.svg";
export { ForwardRef as ReactComponent };